import { render, staticRenderFns } from "./TipoIncidencias.vue?vue&type=template&id=5045c567"
import script from "./TipoIncidencias.vue?vue&type=script&lang=js"
export * from "./TipoIncidencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports